import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import ButtonComponent from "../../../components/button";
import { Tag } from "antd";
import { useNotification } from "../../../context/notifications/notifications-context";

const TeacherNotifications = () => {
  const loggedInUser = useSelector((state) => state.auth.user);

  const [error, setError] = useState("");
  const [filterType, setFilterType] = useState("all");

  const {
    notifications: warnings,
    loading,
    fetchNotifications,
    markAsRead,
  } = useNotification();

  useEffect(() => {
    if (loggedInUser?.id && loggedInUser?.role) {
      fetchNotifications();
    } else {
      console.warn("No logged-in user found");
    }
    // eslint-disable-next-line
  }, [loggedInUser]);

  const filteredWarnings = warnings.filter((warning) => {
    return filterType === "all" || warning.type === filterType;
  });

  // const getWarningTypeColor = (type) => {
  //   const colors = {
  //     attendance: "bg-primary text-white",
  //     behavior: "bg-danger text-white",
  //     academic: "bg-warning text-dark",
  //     discipline: "bg-purple text-white",
  //     general: "bg-secondary text-white",
  //   };
  //   return colors[type] || colors.general;
  // };

  const formatDate = (timestamp) => {
    if (!timestamp) return "N/A";
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    return date.toLocaleDateString() + " " + date.toLocaleTimeString();
  };

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "256px" }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <>
      <h1 className="pageTitle">Notifications</h1>
      {/* <hr /> */}

      <div className="container-fluid p-0">
        <div className="card shadow-sm">
          <div className="card-header bg-white border-bottom">
            {/* <h1 className="h4 mb-0 text-dark">My Warnings</h1> */}

            <div className="d-flex flex-wrap align-items-center gap-3 mt-1">
              <div>
                <select
                  value={filterType}
                  onChange={(e) => setFilterType(e.target.value)}
                  className="form-select"
                >
                  <option value="all">All Types</option>
                  <option value="attendance">Attendance</option>
                  <option value="behavior">Behavior</option>
                  <option value="academic">Academic</option>
                  <option value="discipline">Discipline</option>
                  <option value="general">General</option>
                </select>
              </div>
              <ButtonComponent type="primary" onClick={fetchNotifications}>
                Refresh
              </ButtonComponent>
            </div>
          </div>

          {error && <div className="alert alert-danger m-3">{error}</div>}

          <div className="list-group list-group-flush">
            {filteredWarnings.length === 0 ? (
              <div className="text-center p-5 text-muted">
                No warnings found
              </div>
            ) : (
              filteredWarnings.map((warning) => (
                <div
                  key={warning.id}
                  className={`list-group-item ${
                    !warning.isRead ? "bg-light" : ""
                  }`}
                  style={{
                    transform: "none !important", // Removes any Bootstrap transform effects
                    transition: "none !important", // Disables animations
                  }}
                >
                  <div className="d-flex justify-content-between align-items-start">
                    <div className="flex-grow-1">
                      {/* <div className="d-flex align-items-center gap-2 mb-2">
                        <span
                          className={`badge ${getWarningTypeColor(
                            warning.type
                          )}`}
                        >
                          {warning.type?.toUpperCase()}
                        </span>
                        {!warning.isRead && (
                          <span className="badge bg-success">NEW</span>
                        )}
                      </div> */}
                      <div className="d-flex align-items-center gap-2 mb-2">
                        <Tag
                          color={
                            warning.type === "attendance"
                              ? "blue"
                              : warning.type === "behavior"
                              ? "red"
                              : warning.type === "academic"
                              ? "gold"
                              : warning.type === "discipline"
                              ? "purple"
                              : "grey"
                          }
                        >
                          {warning.type?.toUpperCase()}
                        </Tag>
                        {!warning.isRead && <Tag color="green">NEW</Tag>}
                      </div>

                      <p className="mb-2">{warning.description}</p>

                      <div className="text-muted small">
                        <p className="mb-1">
                          Receiver ID: {warning.receiverId}
                        </p>
                        <p className="mb-1">
                          Created: {formatDate(warning.createdAt)}
                        </p>
                        {warning.readAt && (
                          <p className="mb-0">
                            Read: {formatDate(warning.readAt)}
                          </p>
                        )}
                      </div>
                    </div>

                    {!warning.isRead && (
                      <ButtonComponent
                        type="primary"
                        onClick={() => markAsRead(warning.id)}
                      >
                        Mark as Read
                      </ButtonComponent>
                    )}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default TeacherNotifications;
